import { useLayoutEffect, useRef, useState } from 'react';

export const useOverflowDetection = <T extends HTMLElement = HTMLElement>() => {
  const ref = useRef<T>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    setIsOverflowed(element.scrollWidth > element.clientWidth);
  }, []);

  return { ref, isOverflowed };
};
